import { render, staticRenderFns } from "./CurrentTerm.vue?vue&type=template&id=05d9265b&scoped=true&"
import script from "./CurrentTerm.vue?vue&type=script&lang=js&"
export * from "./CurrentTerm.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTerm.vue?vue&type=style&index=0&id=05d9265b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d9265b",
  null
  
)

export default component.exports